const backendHost = process.env.REACT_APP_BASE_URL
const backendCampaignsHost = process.env.REACT_APP_BASE_URL_CAMPAIGNS
const pk = process.env.REACT_APP_STRIPE_KEY

export const API_ROOT = `${backendHost}`
export const API_ROOT_CAMPAIGNS = `${backendCampaignsHost}`
export const STRIPE_KEY = `${pk}`
